export function CoupleNames({ id }: { id?: string }) {
  return (
    <h1 id={id}>
      Shri Giridhar
      <span className="pair-and">and</span>
      Smt Sharmila
    </h1>
  );
}

export const COUPLE = 'Shri Giridhar and Smt Sharmila';
